export const GREEN_COLOR = "flexidaoGreen";
export const RED_COLOR = "flexidaoRed";

export const DEFAULT_CANCEL_TEXT = "No, cancel";
export const DEFAULT_ACCEPT_TEXT = "Yes, confirm";
